var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecialistActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.02,
    height: 26.984,
    viewBox: "0 0 25.02 26.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23279",
    "data-name": "Group 23279",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13929",
    "data-name": "Path 13929",
    d: "M-5179.431,3332.386a46.373,46.373,0,0,1-7.917-.492c-1.062-.175-2.1-.473-3.133-.749a3.952,3.952,0,0,1-.96-.446,1.8,1.8,0,0,1-.925-2.178,8.2,8.2,0,0,1,1.3-2.523,4.893,4.893,0,0,1,3.6-1.9c.8-.073,1.6-.125,2.4-.175a.381.381,0,0,1,.276.1,2.662,2.662,0,0,0,1.291.883,10.266,10.266,0,0,0,4,.556,9.713,9.713,0,0,0,2.726-.43,3.01,3.01,0,0,0,1.658-1.029.3.3,0,0,1,.222-.086c.97.078,1.942.14,2.906.256a4.544,4.544,0,0,1,3.075,1.751,7.665,7.665,0,0,1,1.39,2.677,1.8,1.8,0,0,1-.969,2.114,10.236,10.236,0,0,1-3.389,1.073A44.75,44.75,0,0,1-5179.431,3332.386Z",
    transform: "translate(5192.458 -3305.405)",
    fill: "#f28900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13930",
    "data-name": "Path 13930",
    d: "M-5122.7,3059.587a6.679,6.679,0,0,1,3.6-5.831c.1.547.19,1.046.28,1.545s.174.994.27,1.489c.066.343.27.5.567.463a.471.471,0,0,0,.409-.6c-.16-1-.335-1.99-.514-2.983a.824.824,0,0,1,.8-1.1,17.137,17.137,0,0,1,2.306.011,1.811,1.811,0,0,1,.78.445c.069.051.085.228.067.337-.167,1.007-.346,2.011-.521,3.016a2.957,2.957,0,0,0-.044.306.483.483,0,0,0,.418.57.481.481,0,0,0,.56-.432c.145-.766.275-1.535.413-2.3.042-.235.088-.47.14-.744a6.539,6.539,0,0,1,2.619,2.413,6.58,6.58,0,0,1,.977,3.393,5.023,5.023,0,0,1,.526.081.96.96,0,0,1,.69.991.96.96,0,0,1-.872.873c-.114.009-.229.007-.344.007q-6.58,0-13.16,0a1.861,1.861,0,0,1-.543-.055.952.952,0,0,1-.639-.961.95.95,0,0,1,.761-.867C-5123,3059.618-5122.854,3059.607-5122.7,3059.587Z",
    transform: "translate(5128.633 -3052.536)",
    fill: "#f28900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13931",
    "data-name": "Path 13931",
    d: "M-5113.762,3200.791h13.916a3.513,3.513,0,0,1-.959,2.792.937.937,0,0,0-.215.336,9.957,9.957,0,0,1-2.848,4.034,4.313,4.313,0,0,1-5.893-.068,10.284,10.284,0,0,1-2.77-3.97,1.393,1.393,0,0,0-.284-.352,2.925,2.925,0,0,1-.292-.287A4.32,4.32,0,0,1-5113.762,3200.791Z",
    transform: "translate(5119.185 -3190.573)",
    fill: "#f28900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialistActive);
export default __webpack_public_path__ + "static/media/specialistActive.41970fd09d832a3f6005e6dcd1e8f558.svg";
export { ForwardRef as ReactComponent };